module.exports = __webpack_public_path__ + "static/img/firstCall.c4d7ec4d.png";